import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

const LabelChip = ({ notes }) => (
  <Chip
    label={notes}
    size="small"
    sx={{
      backgroundColor: '#d9d9d9',
      color: 'text.secondary',
      fontWeight: 600,
      borderRadius: '5999px', // extra-rounded
      px: 1.25,
      height: 24, // keep it compact
    }}
  />
);

LabelChip.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default LabelChip;
